import ChartsService from './Base';

class Users extends ChartsService {
  constructor() {
    super('users');
  }
}

export default new Users();
